import $http from '@/utils/fetch'

const getUserInfo = data => {
  return $http.post('user/info', data)
}

const sendMobileVerify = data => {
  return $http.post('send/sms', data)
}

const login = data => {
  return $http.post('login', data)
}

export default {
  getUserInfo,
  sendMobileVerify,
  login
}
